// components/DeviceStatusAlertDialog.js
import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

class DeviceStatusAlertDialog extends Component {
  formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  render() {
    const { 
      open, 
      title, 
      message, 
      onClose, 
      showAudioOnlyButton, 
      onSwitchToAudioOnly,
      // New props for multiple issues
      issues = [],
    } = this.props;

    // Check if any issue has showAudioOnlyButton
    const hasAudioOnlyOption = issues.length > 0 
      ? issues.some(issue => issue.showAudioOnlyButton)
      : showAudioOnlyButton;

    // Determine if we're showing multiple issues or single issue (backward compatibility)
    const isMultipleIssues = issues.length > 0;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '24px',
            width: '450px',
            maxWidth: '90vw',
            textAlign: 'left',
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ fontWeight: 600, fontSize: '16px', paddingBottom: '0px' }}
        >
          {isMultipleIssues ? 'Device Issues Detected' : title}
        </DialogTitle>
        <DialogContent style={{ paddingTop: '12px' }}>
          {isMultipleIssues ? (
            <Box>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                The following device issues have been detected. Your consultation is still enabled, but you may experience issues during video calls.
              </Typography>
              {issues.map((issue, index) => (
                <Box key={issue.id || index}>
                  {index > 0 && <Divider sx={{ my: 1.5 }} />}
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <WarningAmberIcon sx={{ color: '#ed6c02', fontSize: '1.2rem', mt: 0.3 }} />
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#333' }}>
                        {issue.title}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#555', mt: 0.5 }}>
                        {issue.message}
                      </Typography>
                      {issue.timestamp && (
                        <Typography variant="caption" sx={{ color: '#888', mt: 0.5, display: 'block' }}>
                          Detected: {this.formatTimestamp(issue.timestamp)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: '#555', fontSize: '14px' }}
            >
              {message}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions style={{ justifyContent: 'flex-end', padding: '8px 24px', gap: '8px' }}>
          {hasAudioOnlyOption && onSwitchToAudioOnly && (
            <Button
              onClick={onSwitchToAudioOnly}
              style={{
                color: '#fff',
                backgroundColor: '#6cca98',
                fontWeight: 500,
                textTransform: 'none',
                fontSize: '14px',
                padding: '6px 16px',
              }}
            >
              Switch to Audio-Only Consult
            </Button>
          )}
          <Button
            onClick={onClose}
            style={{
              color: '#1a73e8',
              fontWeight: 500,
              textTransform: 'none',
              fontSize: '14px',
            }}
          >
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DeviceStatusAlertDialog;



// WEBPACK FOOTER //
// ./src/components/common/DeviceStatusAlertDialog.js